import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from 'src/app/services/report.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-binnacle-report',
  templateUrl: './binnacle-report.component.html',
  styleUrls: ['./binnacle-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class BinnacleReportComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data = [];
  loading:boolean = false;
  total:number = 0;
  expand:boolean = false;
  //Pagination
  page: number = 1
  pagination: number = 20;

  constructor(private repServ:ReportService) {
    this.date1.setDate(this.date1.getDate() - 30);
  }

  ngOnInit() {
  }

  search() {
    this.loading = true;
    this.repServ.binnacleReport(this.date1, this.date2)
      .then(resp => {
        this.data = resp;
        //this.total = this.data.reduce((ant, act) => Number(ant) + (act.gas_ticket ? 0 : Number(act.total)), 0)
        this.loading = false;
      });
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/binnacle' + '?date1=' + this.date1.toString() + '&date2=' + this.date2.toString(), '_blank')
  }
}
